module.exports = __webpack_public_path__ + "img/people500.png";